import { ServiceSalaryComponent } from './ServiceSalaryComponent.main';

export { ServiceSalaryComponent };
